import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useHistory } from '../../../utils/reactRouterCompatibility';
import HasCapability from '../../../Route/HasCapability';
import { CircularProgress, Grid, List, ListItem, ListItemIcon, Typography } from '@mui/material';
import ListItemNavLink from '../ListItemNavLink';
import { getFanclubPlansRoute } from '../../../../router/routes/fanclub/factory/plan';
import { MdCardMembership } from 'react-icons/md';
import { getFanclubSubscribersRoute } from '../../../../router/routes/fanclub/factory/subscriber';
import { IoIosPeople } from 'react-icons/io';
import { getFanclubArticlesRoute } from '../../../../router/routes/fanclub/factory/content';
import { FaClipboardList } from 'react-icons/fa';
import { getFanclubWizardRoute } from '../../../../router/routes/fanclub/factory/wizard';
import Button from '../../../common/inputs/Button';
import { hideMenu } from '../../../../store/actions/CommonAction';
import graphic from '../../../../resources/images/fanclub-wizard/step1.svg';

const MenuFanclub = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const history = useHistory();

	const ready = useSelector(state => state.common.ready);
	const selectedFanclub = useSelector(state => state.membership.selectedFanclub);
	const loading = useSelector(state => state.membership.loadingFanclub);
	const fanclub_cms = useSelector(state => state.cms.fanclub_cms);
	const realm = useSelector(state => state.realm.selected);
	const isOwner = useSelector(state => state.access.owner);

	const disabled = loading || selectedFanclub === null || fanclub_cms == null || !ready;
	const displayCreate = ready && !selectedFanclub && realm;

	const handleHideMenu = () => dispatch(hideMenu());

	if (displayCreate && !isOwner) {
		return (
			<List>
				<ListItem>
					<Typography sx={{
						padding: 2,
						textAlign: 'center',
						width: '100%'
					}}>
						{t('fanclub_ask_owner')}
					</Typography>
				</ListItem>
			</List>
		);
	}

	return (
		<HasCapability fanclub hideLoading>
			<List>
				{loading && (
					<ListItem>
						<ListItemIcon>
							<CircularProgress size={15} />
						</ListItemIcon>
					</ListItem>
				)}

				{!displayCreate && (
					<>
						<ListItemNavLink
							tooltip={t('menu_fanclub_plans')}
							disabled={disabled}
							path={getFanclubPlansRoute()}
							icon={<MdCardMembership size={20} />}
							primary={t('menu_plans')}
						/>

						<ListItemNavLink
							tooltip={t('menu_fanclub_members')}
							disabled={disabled}
							path={getFanclubSubscribersRoute()}
							icon={<IoIosPeople size={20} />}
							primary={t('menu_members')}
						/>

						<ListItemNavLink
							tooltip={t('menu_fanclub_articles')}
							disabled={disabled}
							path={getFanclubArticlesRoute()}
							icon={<FaClipboardList size={20} />}
							primary={t('menu_articles')}
						/>
					</>
				)}

				{displayCreate && (
					<ListItem
						onClick={() => {
							handleHideMenu();
							history.push(getFanclubWizardRoute());
						}}
						sx={{ cursor: 'pointer' }}
					>
						<Grid container spacing={2} justifyContent="center">
							<Grid item sx={{ textAlign: 'center' }}>
								<img src={graphic} alt="artist" width="100px" />
							</Grid>
							<Grid item xs={12} />
							<Grid item>
								<Button color="primary" variant="outlined">
									{t('menu_create_fanclub')}
								</Button>
							</Grid>
						</Grid>
					</ListItem>
				)}
			</List>
		</HasCapability>
	);
};

export default MenuFanclub;
